export var MailingMode;
(function (MailingMode) {
    MailingMode[MailingMode["Weekdays"] = 1] = "Weekdays";
    MailingMode[MailingMode["Daily"] = 2] = "Daily";
    MailingMode[MailingMode["Manually"] = 3] = "Manually";
})(MailingMode || (MailingMode = {}));
